<template>
  <div id="pin-searchbox" class="box">
    <input
      id="query"
      :value="query"
      type="search"
      placeholder="Recherche ..."
      @input="$emit('update:query', $event.target.value)"
    >
    <select id="filter" :value="filter" @change="$emit('update:filter', $event.target.value)">
      <option value="all">Tous</option>
      <option value="to_visit">A voir</option>
      <option value="visited">Visités</option>
    </select>
  </div>
</template>

<script setup>
defineProps({
  query: {
    type: String,
    required: true,
  },
  filter: {
    type: String,
    required: true,
  },
})

defineEmits(['update:query', 'update:filter'])
</script>
